module.exports = __webpack_public_path__ + "img/A5.42e2e2d6.png";